import { render, staticRenderFns } from "./pelecard_callback.vue?vue&type=template&id=b336fda4&scoped=true&"
import script from "./pelecard_callback.vue?vue&type=script&lang=js&"
export * from "./pelecard_callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b336fda4",
  null
  
)

export default component.exports